module.exports = __webpack_public_path__ + "static/media/barkbliss-logo.db3416b8.png";